import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PublicSettingDto } from '../../helper/dto/public-settings.dto';
import { AuthApiService } from '../../services/auth-api.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-index',
    standalone: true,
    imports: [CommonModule, RouterModule, ProgressSpinnerModule],
    templateUrl: './index.component.html'
})
export class IndexComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

    oidcEnabled = false;
    oidcForceLogin = false;
    oidcButtonText = '';
    oidcData: PublicSettingDto[] = [];

    showSpinner = false;

    constructor(
        private authService: AuthService,
        private authApiService: AuthApiService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.authApiService.getOIDCData()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (data) => {
                    this.oidcData = data;

                    const oidcButtonText = this.oidcData.find((x: any) => x.key === 'oidc_login_button_text');
                    const oidcEnable = this.oidcData.find((x: any) => x.key === 'oidc_enabled');
                    const oidcForceLogin = this.oidcData.find((x: any) => x.key === 'oidc_force_login');

                    this.oidcEnabled = !!(oidcEnable?.valueBoolean);
                    this.oidcForceLogin = !!(oidcForceLogin?.valueBoolean);

                    if (oidcButtonText?.value) {
                        this.oidcButtonText = oidcButtonText.value;
                    }

                    if (this.oidcEnabled && this.oidcForceLogin) {
                        this.oidcLogin();
                    } else {
                        this.authService.restoreSession().then((ok) => {
                            this.router.navigate([ok ? '/app' : '/login']);
                        });
                    }
                },
                error: (error) => {
                    console.error(error);
                    this.showSpinner = false;
                    this.router.navigate(['/login']);
                }
            });
    }

    oidcLogin() {
        this.showSpinner = true;
        this.route.queryParams.pipe(take(1)).subscribe(params => {
            window.location.href = params['returnUrl']
                ? this.authApiService.apiUrl(`v1/auth/oidc/login?returnUrl=${params['returnUrl']}`)
                : this.authApiService.apiUrl('v1/auth/oidc/login');
        });
    }
}
